export const content = {
    header: {
        home: {
            en: 'Home',
            ru: 'Главная',
        },
        restaurants: {
            en: 'Restaurants',
            ru: 'Рестораны',
        },
        about: {
            en: 'About us',
            ru: 'О нас',
        },
    },
    common: {
        details: {
            en: 'Details',
            ru: 'Подробнее',
        },
        edit: {
            en: 'Edit',
            ru: 'Изменить',
        },
        save: {
            en: 'Save',
            ru: 'Сохранить',
        },
        delete: {
            en: 'Delete',
            ru: 'Удалить',
        },
        cancel: {
            en: 'Cancel',
            ru: 'Отменить',
        },
    },
    homePage: {
        title: {
            en: 'RaViOle - service for online reservation restaurants in your City',
            ru: 'RaViOle - сервис для бронирования столиков в ресторанах вашего города',
        },
        subtitle: {
            en: 'The mission of RaViOle is to provide users with the most complete information about all the institutions of the city, to provide a high-quality service for booking tables and online bookings. And for companies - to provide powerful promotion on the Internet, actively promote business development and increase brand awareness, increase the number of regular customers.',
            ru: 'Миссия RaViOle ― дать пользователям максимально полную информацию обо всех заведениях города, предоставить качественный сервис по бронированию столиков и онлайн-записи. А для компаний ― обеспечить мощное продвижение в интернете, активно способствовать развитию бизнеса и повышению узнаваемости брендов, увеличению количества постоянных клиентов.',
        },
        reviews: {
            en: 'Verified reviews in',
            ru: 'Проверенных отзывов в г.',
        },
        titleSec2: {
            en: 'Why RaViOle?',
            ru: 'Почему RaViOle?',
        },
        subtitleSec2: {
            en: 'Easy and fast restaurant reservations',
            ru: 'Простое и быстрое бронирование',
        },
        advantages: [
            {
                id: 1,
                en: 'Book a table in a few clicks with no calls',
                ru: 'Бронируй столик за несколько кликов без звонков',
            },
            {
                id: 2,
                en: 'Choose the table you like best',
                ru: 'Выбери столик, который тебе больше всего нравится',
            },
            {
                id: 3,
                en: 'Track bookings in your personal account',
                ru: 'Отслеживай свои бронирования в личном кабинете',
            },
            {
                id: 4,
                en: 'Enjoy food in your favorite restaurant',
                ru: 'Наслаждайся едой в любимом ресторане',
            },
        ],
        titleSec3: {
            en: 'RaViOle recommend',
            ru: 'RaViOle рекомендует',
        },
        subtitleSec3: {
            en: 'The most popular restaurants in your City',
            ru: 'Популярные рестораны вашего города',
        },
    },
    restaurantCart: {
        adress: {
            en: 'Adress',
            ru: 'Адрес',
        },
        phone: {
            en: 'Phone',
            ru: 'Телефон',
        },
        workTime: {
            en: 'Work time',
            ru: 'Время работы',
        },
        averageCheck: {
            en: 'Average check',
            ru: 'Средний чек',
        },
        cuisine: {
            en: 'Cuisine',
            ru: 'Кухня',
        },
    },
    RegistrationProposal: {
        titleForGuest: {
            en: 'Sync up with RaViOle.',
            ru: 'Создайте аккаунт на RaViOle.',
        },
        subtitleForGuest: {
            en: 'Join our community and make your first online reservation',
            ru: 'Присоединяйтесь к нашему сообществу и сделайте свое первое онлайн-бронирование',
        },
        join: {
            en: 'Join',
            ru: 'Присоединяйтесь',
        },
        titleForUser: {
            en: 'Hello',
            ru: 'Приветствуем',
        },
        subtitleForUser: {
            en: 'Click the button below and start booking table in your favorite restaurant',
            ru: 'Нажмите на кнопку ниже и бронируйте столик в любимом ресторане',
        },
        getStarted: {
            en: 'Get started',
            ru: 'К ресторанам',
        },
    },
    restaurantsPage: {
        title: {
            en: 'Restaurants in ',
            ru: 'Рестораны города ',
        },
        averageCheck: {
            en: 'Average check: ',
            ru: 'Средний чек: ',
        },
        cuisineType: {
            en: 'Cuisine: ',
            ru: 'Кухня: ',
        },
        book: {
            en: 'Book',
            ru: 'Бронировать',
        },
        favorites: {
            en: 'Favorites',
            ru: 'Избранное ',
        },
        review: {
            en: 'Review',
            ru: 'Отзыв',
        },
        about: {
            en: 'About us',
            ru: 'О нас ',
        },
        menu: {
            en: 'Menu',
            ru: 'Меню',
        },
        location: {
            en: 'Location',
            ru: 'Местоположение',
        },
        reviews: {
            en: 'Reviews',
            ru: 'Отзывы',
        },
        titleClose: {
            en: 'Closed',
            ru: 'Закрыто',
        },
        titleOpen: {
            en: 'Open now',
            ru: 'Открыто',
        },
        noReviews: {
            en: 'No reviews',
            ru: 'Нету отзывов',
        },
    },
    errorPage: {
        title: {
            en: 'Error',
            ru: 'Ошибка',
        },
        subtitle: {
            en: 'The page you are looking for can`t be found',
            ru: 'Такой страницы не существует',
        },
    },
    registration: {
        signin: {
            en: 'Sign in to your account',
            ru: 'Войдите в ваш аккаунт',
        },
        or: {
            en: 'or ',
            ru: 'или ',
        },
        registerForm: {
            en: 'Create an account',
            ru: 'Создайте аккаунт',
        },
        registerBtn: {
            en: 'Register',
            ru: 'Зарегистрироваться',
        },
        login: {
            en: 'Login',
            ru: 'Логин',
        },
        phone: {
            en: 'Phone',
            ru: 'Телефон',
        },
        emailadress: {
            en: 'Email address',
            ru: 'Email адрес',
        },
        password: {
            en: 'Password',
            ru: 'Пароль',
        },
        submit: {
            en: 'Sing in',
            ru: 'Войти ',
        },
    },
    userPage: {
        phone: {
            en: 'Phone',
            ru: 'Телефон',
        },
        bookings: {
            en: 'My bookings',
            ru: 'Мои бронирования',
        },
        reviews: {
            en: 'My reviews',
            ru: 'Мои отзывы',
        },
        favorites: {
            en: 'My favorite restaurants',
            ru: 'Избранное',
        },
        logout: {
            en: 'Log out',
            ru: 'Выйти',
        },
        changeInfo: {
            en: 'Change personal information',
            ru: 'Изменение данных пользователя',
        },
        settings: {
            en: 'Settings',
            ru: 'Настройки',
        },
        nobookings: {
            en: 'You have no booking yet',
            ru: 'У вас еще нет бронирований',
        },
        noreviews: {
            en: 'You have no reviews yet',
            ru: 'Вы еще не оставляли отзывы',
        },
        nofavourites: {
            en: 'You have no favourites restaurants yet',
            ru: 'Вы еще не добавляли рестораны в избранное',
        },
        prevPassword: {
            en: 'Current password',
            ru: 'Текущий пароль',
        },
        newPassword: {
            en: 'New password',
            ru: 'Новый пароль',
        },
        yourLevel: {
            en: 'Your level',
            ru: 'Ваш уровень',
        },
        bonusPoints: {
            en: 'bonus points',
            ru: 'бонусов',
        },
        newbie: {
            en: 'Newbie',
            ru: 'Новичок',
        },
        heavyEater: {
            en: 'Heavy eater',
            ru: 'Любитель',
        },
        gourmet: {
            en: 'Gourmet',
            ru: 'Гурман',
        },
    },
    booking: {
        duration: {
            en: 'Duration',
            ru: 'Длительность',
        },
        hours: {
            en: 'h',
            ru: 'ч',
        },
        forPersons: {
            en: 'for',
            ru: 'для',
        },
        forDuration: {
            en: 'for',
            ru: 'на',
        },
        person: {
            en: 'person',
            ru: 'чел.',
        },
        table: {
            en: 'Table',
            ru: 'Столик',
        },
        guest: {
            en: 'Guest name: ',
            ru: 'Имя гостя: ',
        },
    },
    error: {
        wrongloginOrEmail: {
            en: 'Wrong username or password',
            ru: 'Неверное имя пользователя или пароль',
        },
        userExsist: {
            en: 'Login or email is already taken',
            ru: 'Логин или email уже зарегистрирован',
        },
        shortLogin: {
            en: 'Login should contain at least 3 characters (acceptably: latin letters, digits and -$#@._)',
            ru: 'Логин должен содержать минимум 3 символа (допустимо: латинские буквы, цифры и -$#@._)',
        },
        wrongPhone: {
            en: 'Phone should start with "+" and contain minimum 9 numbers',
            ru: 'Телефон должен начинаться с "+" и состоять минимум из 9 цифр',
        },
        wrongEmail: {
            en: 'Incorrect email adress',
            ru: 'Некорректный email адрес',
        },
        shortPassword: {
            en: 'Password should contain minimum 6 characters',
            ru: 'Пароль должен содержать минимум 6 символов',
        },
        wrongPassword: {
            en: 'Incorrect previous password',
            ru: 'Неверный пароль',
        },
    },
    bookingModal: {
        btnNext: {
            en: 'Next',
            ru: 'Вперед',
        },
        btnPrev: {
            en: 'Back',
            ru: 'Назад',
        },
        btnBook: {
            en: 'Book',
            ru: 'Отправить',
        },
        selectedDate: {
            en: 'Selected date',
            ru: 'Выбранная дата',
        },
        bookingTime: {
            en: 'Booking time: 1 hour',
            ru: 'Время бронирования: 1 час',
        },
        guestsNumber: {
            en: 'Guests number',
            ru: 'Количество гостей',
        },
        name: {
            en: 'Name',
            ru: 'Имя',
        },
        namePlaceholder: {
            en: 'Name',
            ru: 'Имя',
        },
        nameText: {
            en: 'Must start with capital letter and contain at least 2 letters',
            ru: 'Должно начинаться с заглавной буквы и быть не менее двух букв',
        },
        phone: {
            en: 'Phone',
            ru: 'Телефон',
        },
        phonePlaceholder: {
            en: 'Phone number',
            ru: 'Номер телефона',
        },
        phoneText: {
            en: 'Must begin with "+" and contain at least 9 numbers',
            ru: 'Должен начинаться с "+" и состоять минимум из 9 цифр',
        },
        comment: {
            en: 'Comment',
            ru: 'Комментарий',
        },
        commentPlaceholder: {
            en: 'Your special wishes and preferences',
            ru: 'Ваши особые пожелания и предпочтения',
        },
        optional: {
            en: 'optional',
            ru: 'опционально',
        },
        date: {
            en: 'Date',
            ru: 'Дата',
        },
        time: {
            en: 'Time',
            ru: 'Время',
        },
        table: {
            en: 'Table',
            ru: 'Стол',
        },
        finishBooking: {
            en: 'Your booking has been accepted 👌',
            ru: 'Ваша бронь принята 👌',
        },
        guestsPerTable: {
            en: '*max: 4 guests per table',
            ru: '*макс: 4 гостя за столом',
        },
        guestText: {
            en: 'Please login or create an account',
            ru: 'Пожалуйста, зарегистрируйтесь или войдите в аккаунт',
        },
        guestBtnText: {
            en: 'Registration',
            ru: 'Регистрация',
        },
    },
    reviewModal: {
        title: {
            en: 'Review about restaurant',
            ru: 'Отзыв о ресторане',
        },
        label: {
            en: 'Your review',
            ru: 'Ваш отзыв',
        },
        errorMsgReview: {
            en: 'Review should contain more than 5 words',
            ru: 'Отзыв должен содержать более чем 5 слов',
        },
        errorMsgRating: {
            en: 'Rating should be more than 0',
            ru: 'Рейтинг должен быть больше 0',
        },
        noBookingRedirect: {
            en: 'If you want to leave a review, you need to reserve a table in this restaurant',
            ru: 'Если Вы хотите оставить отзыв, сначала следует забронировать столик в этом ресторане',
        },
    },
};
